import React, { useCallback } from 'react';
import ReactDOM from 'react-dom';
import cn from 'classnames';
import styled from 'styled-components';
import { CloseIcon } from '../icons';
import ButtonGeneral from '../ButtonGeneral';
import { customMediaQuery } from '../../styled';

interface IProps {
  children: React.ReactNode;
  onClose?: () => void;
  className?: string;
}

const LinguNotification: React.FC<IProps> = ({ children, className, onClose }) => {
  const handleClose = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  return ReactDOM.createPortal(
    <SNotification>
      <SWrapper className={cn(className)}>
        {children}
        <SCloseButton onClick={handleClose}>
          <SCloseIcon color="#A7AAB6" />
        </SCloseButton>
      </SWrapper>
    </SNotification>,
    document.querySelector('body') as HTMLElement
  );
};

export default LinguNotification;

const SNotification = styled.div`
  position: fixed;
  bottom: 36px;
  z-index: 1000;
  right: 50%;
  transform: translateX(50%);
  width: 100%;
  font-size: 0.875rem;
  font-weight: 500;

  ${customMediaQuery('tablet')} {
    width: auto;
    right: 32px;
    transform: unset;
    font-size: 1rem;
  }
`;

const SWrapper = styled.div`
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  position: relative;
  max-width: 372px;
  padding: 14px 19px;
  word-break: break-word;
`;

const SCloseButton = styled(ButtonGeneral)`
  background-color: transparent;
  position: absolute;
  top: 12px;
  right: 12px;
`;

const SCloseIcon = styled(CloseIcon)`
  min-width: 12px;
  min-height: 12px;
`;
